var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-version"},[_c('span',[_vm._v("App version "+_vm._s(_vm.appVersion))])])
}
var staticRenderFns = []

export { render, staticRenderFns }